import React, { useState, useEffect } from "react";

// import { CheckboxBase } from "../../atoms/checkbox";
// import { RHFCurrencyTextField } from "../../rhfCurrencyTextField";
// import { Section } from "../../particles/layout/section";
// import { LabelTooltip } from "../../organisms/labelTooltip";

// import StarBorder from "@mui/icons-material/StarBorder";
import CircleIcon from "@mui/icons-material/Circle";

import {
  CheckboxBase,
  RHFCurrencyTextField,
  Section,
  LabelTooltip,
} from "@arp/react-ndbx";

import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Fade,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

//* Utilities
import { formatCurrencyNoDecimal } from "../../../utilities/numericFormat.js";

//----------------------------------------------------------------

export default function OutcomeCurrencyInputCard({ sx = [], ...props }) {
  const theme = useTheme();
  const {
    name,
    headline = null,
    title,
    subTitle,
    subTitleJsx = false,
    backgroundColor = theme.palette.soft.softBeige15,
    variant = "standard",
    showTooltip = true,
    showPremium = false,
    showCheckbox = false,
    checked = false,
    showSpecialTerms = false,
    specialTerms = [],
    hasLoading = false,
    loadings = 0,
    tooltipText,
    tooltipWidth,
    frequency,
    premiumAmount = "$0.00",
    maxWidth = "690px",
    checkedOnChange,
    inputRef,
    person = "personOne",
    ...rest
  } = props;

  const labelAria = { inputProps: { "aria-label": `${name}-checkbox` } };

  //----------------------------------------------------------------
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChecked = (e) => {
    setIsChecked((prev) => !prev);
    checkedOnChange(e);
  };

  const buildListItem = (primaryDetails, index) => {
    return (
      <ListItem
        key={`${name}-additional-loading-${index}`}
        sx={{
          pl: 0,
          pt: 0.5,
          pb: 0,
          display: "flex",
          alignItems: "baseline",
        }}
        disableGutters
        disableRipple
      >
        <ListItemIcon sx={{ minWidth: "24px" }}>
          <CircleIcon
            sx={{
              fill: "#414141",
              height: "8px",
              width: "8px",
            }}
          />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            variant: "p3",
          }}
          primary={primaryDetails}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            fontSize: "16px",
          }}
        />
      </ListItem>
    );
  };

  const buildSpecialTerms = ({ hasLoading = false, loadings = 0 }) => {
    return (
      <Section
        mt={4}
        pl={0}
        ml={0}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          outline: "0px solid red",
        }}
      >
        <Stack sx={{ outline: "0px green solid", alignItems: "flex-start" }}>
          <Typography variant="p3-bold">
            Special Terms and Conditions
          </Typography>
          <List>
            {specialTerms?.map((child, index) => {
              return buildListItem(child, index);
            })}
            {hasLoading === true
              ? buildListItem(`A premium increase ("loading") of ${loadings}%`)
              : null}
          </List>
        </Stack>
      </Section>
    );
  };
  //----------------------------------------------------------------

  return (
    <Card
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: { backgroundColor },
      }}
    >
      <Section mt={0} mb={0}>
        <CardContent
          sx={{
            maxWidth: { maxWidth },
            p: 3,
            pl: { xs: showCheckbox ? 7 : 3, md: 3 },
          }}
        >
          <Stack sx={{ width: "100%" }}>
            {headline ? (
              <Stack
                direction="row"
                sx={{
                  mb: 2,
                  alignItems: "start",
                  ml: showCheckbox ? -8 : 0,
                }}
              >
                {showCheckbox && (
                  <CheckboxBase
                    label={null}
                    {...labelAria}
                    // defaultChecked={isChecked}
                    checked={isChecked}
                    onChange={handleChecked}
                    name={name}
                  />
                )}
                {headline}
              </Stack>
            ) : null}
            <Stack
              direction="row"
              sx={{
                mb: 2,
                alignItems: "center",
                ml: showCheckbox && headline === null ? -8 : 0,
              }}
            >
              {showCheckbox && headline === null ? (
                <CheckboxBase
                  label={null}
                  {...labelAria}
                  // defaultChecked={isChecked}
                  checked={isChecked}
                  onChange={handleChecked}
                  name={name}
                />
              ) : null}
              <Typography
                sx={{ width: "auto !important" }}
                variant="label-large-bold"
              >
                {title}
              </Typography>
              {showTooltip ? (
                <LabelTooltip
                  controlIdentifier={`${name}-checkbox-tooltip`}
                  tooltipTitle={tooltipText}
                  width={tooltipWidth}
                />
              ) : null}
            </Stack>
            {subTitleJsx ? (
              <Typography
                variant="label-medium-regular"
                sx={{ mb: 2, mt: showCheckbox ? -1 : 0 }}
              >
                {subTitle}
              </Typography>
            ) : (
              <Typography
                variant="label-medium-regular"
                dangerouslySetInnerHTML={{
                  __html: subTitle,
                }}
                sx={{ mb: 2, mt: showCheckbox ? -1 : 0 }}
              ></Typography>
            )}
            {(isChecked || !showCheckbox) && (
              <Fade in={isChecked || !showCheckbox} timeout={500}>
                <div>
                  <RHFCurrencyTextField
                    name={name}
                    variant={variant}
                    inputRef={inputRef}
                    {...rest}
                  />
                  {showPremium && (
                    <Fade in={showPremium} timeout={500}>
                      <Box>
                        <Section mt={2} mb={0} sx={{ display: "flex" }}>
                          <Stack
                            sx={{
                              outline: "0px solid red",
                              alignItems: "flex-start",
                            }}
                          >
                            <Typography variant="p2-bold">{`${frequency} Premium`}</Typography>
                            <Typography variant="p2-bold" sx={{ fontSize: 18 }}>
                              {premiumAmount}
                            </Typography>
                          </Stack>
                        </Section>
                      </Box>
                    </Fade>
                  )}
                </div>
              </Fade>
            )}
            {(showSpecialTerms || hasLoading) &&
              buildSpecialTerms({ hasLoading, loadings })}
          </Stack>
        </CardContent>
      </Section>
    </Card>
  );
}
